import { createLazyLocalMutationResolver } from 'owa-lazy-resolver';

export const lazyRenameFolder = createLazyLocalMutationResolver(
    'MUTATION_RENAME_FOLDER',
    () => import('./renameFolderLocal'),
    m => m.renameFolder
);
